import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { useRecoilState, useRecoilValue } from "recoil";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import styled from "styled-components";
import {
  CategoryType,
  ProductType,
  badgeType,
  storeDetailType,
  storeImageType,
  storeType,
} from "../../controller/StoreController";
import { langState, langText } from "../../recoil/lang";

import { useNavigate } from "react-router-dom";
import LogController from "../../controller/LogController";
import { qrAuthState, qrAuthType } from "../../recoil/auth";
import { PRODUCT_TYPE_EXTENSION } from "../../recoil/type";
import {
  contentName,
  formatPhoneNumber,
  getCategoryName,
  getPrdDescription,
  getPrdName,
  getStoreDetail,
  getStoreEvent,
  getStoreNoti,
} from "../../utils/util";

type MenuInfoProps = {
  storeId: number;
  menuInfo: CategoryType[];
  storeInfo: storeType | undefined;
  storeDetailInfo: storeDetailType[];
  scrollTop?: boolean;
  setScrollTop?: any;
  storeList: any;
};

let timer: any;

const MenuInfo = ({
  storeId,
  menuInfo,
  storeInfo,
  storeDetailInfo,
  scrollTop,
  setScrollTop,
  storeList,
}: MenuInfoProps) => {
  const navigate = useNavigate();

  const categoryScrollRef = useRef<HTMLDivElement>(null);
  const scrollRef = useRef<HTMLDivElement>(null);
  const childRef = useRef<HTMLDivElement>(null);
  const [selectedCategory, setSelectedCategory] = useState<number>(0);

  const [isScroll, setIsScroll] = useState<boolean>(false);
  const [lang, setLang] = useRecoilState<number>(langState);
  const [storeInfoIndex, setStoreInfoIndex] = useState<number[]>([]);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        const children = scrollRef.current.children;

        for (let i = 0; i < children.length; i++) {
          const selectedCategoryElement = categoryScrollRef.current?.children[
            i
          ] as HTMLDivElement | undefined;

          const childRect = (
            children[i] as HTMLElement
          ).getBoundingClientRect();

          if (!isScroll) {
            if (childRect.top >= 100) {
              setSelectedCategory(i);
              // console.log("selectedCategoryElement", selectedCategoryElement);

              if (selectedCategoryElement) {
                selectedCategoryElement.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",
                });
              }
              break;
            }
          }
        }
      }
    };

    const scrollElement = scrollRef.current;

    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => {
        scrollElement.removeEventListener("scroll", handleScroll);
      };
    }
  }, [menuInfo, isScroll]);

  // 카테고리
  const onClickCategory = (item: CategoryType, index: number) => {
    selectCategory(index);
    try {
      LogController.click({
        path: "MenuInfo",
        params: "category",
        params2: `${storeInfo?.store_name}: ${item.category_name}`,
        index: item.category_id,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const selectCategory = (index: number) => {
    setSelectedCategory(index);
    const selectedElement = scrollRef.current?.children[index] as
      | HTMLDivElement
      | undefined;

    setIsScroll(true);

    clearTimeout(timer);
    timer = setTimeout(() => setIsScroll(false), 1300);

    if (selectedElement) {
      selectedElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    setSelectedCategory(0);
  }, [storeInfo]);

  // 카테고리
  const renderCategoryList = () => {
    return (
      <div className="category" ref={categoryScrollRef}>
        {menuInfo.map((item: CategoryType, index: number) => {
          return (
            <div
              className={`productWrap ${
                selectedCategory === index && "active"
              }`}
              key={index}
            >
              <div
                className="product"
                onClick={() => {
                  onClickCategory(item, index);
                }}
              >
                <h2 className="categoryName">{getCategoryName(item, lang)}</h2>
                {item.is_for_adult === 1 && (
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_adult.svg`}
                    alt="주류"
                  />
                )}
              </div>
              <div className="bottomLine" />
            </div>
          );
        })}
        {/* 매장소개 */}
        <div
          className={`productWrap ${
            selectedCategory === menuInfo.length && "active"
          }`}
        >
          <div
            className="product"
            onClick={() => selectCategory(menuInfo.length)}
          >
            <h2 className="categoryName">
              {langText.menuInfo_category_storeInfo[lang]}
            </h2>
          </div>
          <div className="bottomLine" />
        </div>
      </div>
    );
  };

  const onChangeStoreInfoIndex = (arrayIndex: number, index: number) => {
    let storeImageTemp = storeInfoIndex;
    storeImageTemp[arrayIndex] = index;
    setStoreInfoIndex([...storeImageTemp]);
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    // autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const renderProductList = () => {
    const navigateMenuDetail = (
      category: CategoryType,
      product: ProductType
    ) => {
      try {
        LogController.click({
          path: "MenuInfo",
          params: "product",
          params2: `${storeInfo?.store_name}: ${product.prd_name}`,
          index: product.prd_id,
        });
      } catch (err) {
        console.log(err);
      }

      navigate("/menu", {
        state: {
          storeInfo: storeInfo,
          category: category,
          product: product,
        },
      });
    };

    return (
      <div
        className={`menu ${storeList.length > 1 && "multiStore"}`}
        ref={scrollRef}
      >
        {menuInfo.map((item: CategoryType, category_index: number) => {
          return (
            menuInfo?.length > 0 && (
              <div className="menuWrapper" key={category_index}>
                {item.product_list.map(
                  (product: ProductType, product_index: number) => {
                    return (
                      <div
                        ref={childRef}
                        key={product_index}
                        className={`itemWrapper`}
                        onClick={() => navigateMenuDetail(item, product)}
                      >
                        <div className="prdInfoWrap">
                          <div className="badgeWrap">
                            {product.badge_list.length > 0 &&
                              product.badge_list.map((badge: badgeType) => (
                                <div
                                  className="badge"
                                  style={{
                                    background: badge.badge_background,
                                  }}
                                >
                                  <p>{contentName(badge.badge_name, lang)}</p>
                                </div>
                              ))}
                            {product.is_set === 1 && (
                              <div className="badge set">
                                <p>SET MENU</p>
                              </div>
                            )}
                            {product.confirm_type === 2 && (
                              <div className="badge autoConfirm">
                                <p>
                                  {langText.menuInfo_badge_autoConfirm[lang]}
                                </p>
                              </div>
                            )}
                          </div>
                          <div className="prdTitleWrap">
                            <h2 className="name">
                              {getPrdName(product, lang)}
                            </h2>
                            <div>
                              <h2>{product.prd_base_price_nrm}원</h2>
                              {product.prd_discount_percentage !== 0 && (
                                <div className="discountWrap">
                                  <h4>{product.prd_org_price_nrm}원</h4>
                                  <span>
                                    {product.prd_discount_percentage}%
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="prdDescriptionWrap">
                            {product.prd_description && (
                              <h5>{getPrdDescription(product, lang)}</h5>
                            )}
                          </div>
                        </div>
                        <div className="imgWrap">
                          {product.url_path !== null ? (
                            <img
                              className="menuImg"
                              src={product.url_path}
                              alt="메뉴이미지"
                              width={"100%"}
                            />
                          ) : product.prd_type === PRODUCT_TYPE_EXTENSION ? (
                            <img
                              src={`${process.env.PUBLIC_URL}/knockknock/img/CheckoutExtension.png`}
                              alt="연장"
                              width={"100%"}
                              className={`menuImg`}
                              style={{ filter: "brightness(0.7)" }}
                            />
                          ) : (
                            <div className="menuImg" />
                          )}
                          {/* 연장 상품 */}
                          {product.prd_type === PRODUCT_TYPE_EXTENSION &&
                            product.hour_extension && (
                              <div className="soldOutWrap">
                                <h2>{product.hour_extension}시간</h2>
                              </div>
                            )}
                          {/* 품절시 */}
                          {product.is_soldout === 1 && (
                            <div className="soldOutWrap">
                              <h2>SOLD OUT</h2>
                            </div>
                          )}
                          <img
                            className="addIcon"
                            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_add.svg`}
                            alt="추가하기"
                          />
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            )
          );
        })}
        <div className="storeDetailWrap">
          {storeDetailInfo.length > 0 && (
            <div className="storeInfoContent">
              <h4 className="title">{langText.menuInfo_store_info[lang]}</h4>
            </div>
          )}
          {storeDetailInfo.map((item: storeDetailType, index: number) => {
            return (
              item.store_image.length > 0 && (
                <>
                  <div className="storeContent" key={index}>
                    <Slider
                      className="slider"
                      {...settings}
                      afterChange={(imgIndex: number) => {
                        onChangeStoreInfoIndex(index, imgIndex);
                      }}
                    >
                      {item.store_image.map(
                        (obj: storeImageType, index: number) => {
                          return (
                            <img
                              key={index}
                              className="storeDetailImage"
                              src={obj.url_path}
                              alt="img"
                            />
                          );
                        }
                      )}
                    </Slider>
                    <div className="imageCount">
                      <p>
                        {storeInfoIndex[index] + 1} / {item.store_image.length}
                      </p>
                    </div>
                  </div>
                  <p className="storeContentText">
                    {getStoreDetail(item, lang)}
                  </p>
                </>
              )
            );
          })}
          {storeInfo && (
            <>
              <div className="storeInfoContent">
                <h4 className="title">
                  {langText.menuInfo_delivery_info[lang]}
                </h4>
                <p>
                  <span>{langText.menuInfo_delivery_time[lang]}</span>
                  {storeInfo.delivery_estimated_time}
                  {langText.minute[lang]}
                </p>
                <p>
                  <span>
                    {langText.paymentListModal_title_delivery_cost[lang]}
                  </span>
                  {storeInfo.base_delivery_price > 0
                    ? `${storeInfo.base_delivery_price.toLocaleString()}원`
                    : `${langText.menuInfo_none[lang]}`}
                </p>
                <p>
                  <span>{langText.menuInfo_base_delivery_price[lang]}</span>
                  {storeInfo.limit_order_price > 0
                    ? `${storeInfo.limit_order_price.toLocaleString()}원`
                    : `${langText.menuInfo_none[lang]}`}
                </p>
                {storeInfo.description_business_time !== null && (
                  <p>
                    <span>{langText.menuInfo_business_time[lang]}</span>
                    {storeInfo.description_business_time}
                  </p>
                )}
              </div>
              <div className="storeInfoDetail">
                {storeInfo.description_event !== "" &&
                  storeInfo.description_event !== null && (
                    <div className="storeInfoContent">
                      <h4 className="title">{langText.menuInfo_event[lang]}</h4>
                      <p>{getStoreEvent(storeInfo, lang)}</p>
                    </div>
                  )}
                {storeInfo.description_noti !== "" &&
                  storeInfo.description_noti !== null && (
                    <div className="storeInfoContent">
                      <h4 className="title">
                        {langText.menuInfo_notification[lang]}
                      </h4>
                      <p>{getStoreNoti(storeInfo, lang)}</p>
                    </div>
                  )}
                <div className="storeInfoContent">
                  <h4 className="title">
                    {langText.menuInfo_origin_info[lang]}
                  </h4>
                  <p>{storeInfo.description_extra}</p>
                </div>
              </div>
              <div className="storeInfoContent">
                <h4 className="title">{langText.call[lang]}</h4>

                <p>
                  <span>{langText.menuInfo_store_tel[lang]}</span>
                  {formatPhoneNumber(storeInfo.phone_number)}
                </p>
                <p>
                  <span>{langText.menuInfo_address[lang]}</span>
                  {storeInfo.address1} {storeInfo.address2}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  // 매장이동하면 화면 맨위로 이동
  useEffect(() => {
    if (scrollTop && scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: "auto",
      });
      return setScrollTop(false);
    }
  }, [scrollTop]);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        const parentRect = scrollRef.current.getBoundingClientRect();
        const children = scrollRef.current.children;

        const scrollElement = scrollRef.current;

        for (let i = 0; i < children.length; i++) {
          const childRect = (
            children[i] as HTMLElement
          ).getBoundingClientRect();

          const selectedIndex = selectedCategory;

          if (!isScroll) {
            if (
              scrollElement.scrollHeight - scrollElement.scrollTop <=
              scrollElement.clientHeight
            ) {
              setSelectedCategory(children.length - 1);
            } else if (childRect.bottom >= parentRect.top) {
              setSelectedCategory(i);
              break;
            }
          } else {
            if (
              i === selectedIndex &&
              Math.abs(childRect.top - parentRect.top) < 1
            ) {
              setIsScroll(false);
              console.log("selected scroll end");
              break;
            }
          }
        }
      }
    };

    const scrollElement = scrollRef.current;

    console.log("scrollRef", scrollRef, menuInfo);

    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => {
        scrollElement.removeEventListener("scroll", handleScroll);
      };
    }
  }, [menuInfo, isScroll]);

  useEffect(() => {
    setStoreInfoIndex(new Array(storeDetailInfo.length).fill(0));
  }, [storeDetailInfo]);

  return (
    <>
      <Style>
        {renderCategoryList()}
        {renderProductList()}
      </Style>
    </>
  );
};
export default MenuInfo;

const Style = styled.div`
  /* menuWrap */
  .storeInfoContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 50px;

    h4 {
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
    h4.title {
      width: 100%;
      text-align: center;
      padding: 8px 0;
      border-top: 1px solid #ffffff;
      border-bottom: 1px solid #ffffff;
      font-weight: 600;
    }
    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 18px;
      word-break: keep-all;
      display: flex;
      align-items: center;
    }
    span {
      display: inline-block;
      width: 130px;
      font-weight: 600;
    }
  }

  .menuContent {
    height: auto;
    display: flex;
  }

  /* 카테고리 */
  .category {
    position: sticky;
    display: flex;
    width: 100%;
    overflow-x: auto;
    top: 0;
    background: #000000;
    padding: 10px;
    z-index: 3;
  }

  .productWrap {
    flex: 1;
    .product {
      min-width: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 4px 12px;
      img {
        width: 18px;
        height: 18px;
      }
    }
    .bottomLine {
      width: 100%;
      height: 5px;
      background: #262626;
      z-index: 4;
    }
    .categoryName {
      font-size: 16px;
      line-height: 24px;
      font-weight: 300;
      color: #eee;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .productWrap.active {
    .bottomLine {
      border-radius: 5px;
      background: #4dd2ae;
    }
    .categoryName {
      font-weight: 600;
      color: #4dd2ae;
    }
  }

  /* 메뉴 */
  .menu {
    height: calc(100dvh - 220px);
    overflow-y: scroll;
    box-sizing: border-box;
    padding: 0 20px;
  }
  .itemWrapper {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 0;
    border-bottom: 2px solid #262626;
    text-align: center;
  }

  .prdInfoWrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0 10px;
    .badgeWrap {
      display: flex;
      align-items: center;
      gap: 4px;
      height: 22px;
      .badge {
        padding: 1px 8px 1px 8px;
        border-radius: 50px;
        text-align: center;
        z-index: 2;
        p {
          font-size: 10px;
          line-height: 14px;
          font-weight: 600;
          color: #ffffff;
        }
      }
      .badge.set {
        padding: 0px 7px;
        border: 1px solid #979797;
        background: #262626;
      }
      .badge.autoConfirm {
        background: #ff4a4a;
      }
    }

    @keyframes flowRight {
      0% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
      }
      100% {
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
      }
    }

    .prdTitleWrap {
      width: 100%;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      h2 {
        max-width: 25vw;
        font-size: 18px;
        line-height: 26px;
        color: #fff;
        font-weight: 600;
        white-space: nowrap;
        word-break: break-all;
      }
      h2.name {
        flex: 1;
        max-width: 30vw;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .prdDescriptionWrap {
      width: 100%;
      height: 32px;
      text-align: left;
      h5 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 12px;
        line-height: 16px;
        color: #a7a7a7;
        font-weight: 300;
        overflow: hidden;
        word-break: break-word;
        text-overflow: ellipsis;
      }
    }
  }

  .imgWrap {
    position: relative;
    .detailButton {
      position: absolute;
      right: 4px;
      top: 4px;
      padding: 3px 10px;
      border-radius: 50px;
      background: #cccccc;
      z-index: 1;
      p {
        font-size: 12px;
        line-height: 16px;
        color: #fff;
        font-weight: 600;
      }
    }
    .addIcon {
      position: absolute;
      height: 28px;
      right: 4px;
      bottom: 8px;
    }
  }
  .menuImg {
    width: 100px;
    height: 80px;
    border-radius: 5px;
  }

  .soldOutWrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 5px;

    h2 {
      height: 100%;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .clickBackground {
    width: 100%;
    height: 100%;
    position: absolute;
    background: red;
    top: 0;
    opacity: 0;
  }
  .clickBackground.active {
    opacity: 0.5;
  }
  .discountWrap {
    display: flex;
    align-items: center;
    justify-content: center;

    h4 {
      margin-right: 4px;
      font-size: 10px;
      line-height: 14px;
      font-weight: 600;
      color: #555;
      text-decoration: line-through;
    }
    span {
      font-size: 10px;
      line-height: 14px;
      font-weight: 700;
      color: #ff0000;
    }
  }

  /* 매장소개 */
  .storeDetailWrap {
    margin-top: 40px;
    padding-top: 10px;
    h2 {
      padding: 8px 0 0 0;
    }
  }
  .storeInfoContent {
    margin-bottom: 40px;
    p {
      font-size: 12px;
    }
  }

  /* h4 {
      text-align: center;
      margin-bottom: 4px;
      font-size: 16px;
      font-weight: 600;
      color: #fff;

      span {
        margin-left: 12px;
        font-size: 16px;
        font-weight: 400;
      }
      .businessTime {
        margin-top: 6px;
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: 400;
        color: #fff;
        white-space: pre-line;
      }
    } */
  .storeContent {
    position: relative;

    .slider {
      width: 100%;
      height: 180px;
    }
    .storeDetailImage {
      width: 100%;
      height: 180px;
      object-fit: cover;
    }

    .imageCount {
      position: absolute;
      bottom: 10px;
      right: 10px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50px;

      p {
        padding: 3px 14px 2px 14px;
        margin: 0;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
  .storeContentText {
    margin-bottom: 30px;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    word-break: keep-all;
  }
`;
